import { SVGProps } from 'react'

export const EdgeCachingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.4043 3.22549C13.6692 3.33885 13.8223 3.61862 13.7749 3.90285L12.6531 10.6336L18.1307 10.6336C18.3674 10.6336 18.5839 10.7673 18.6897 10.979C18.7956 11.1908 18.7728 11.4442 18.6307 11.6336L11.1723 21.5782C10.9994 21.8087 10.6913 21.8911 10.4264 21.7778C10.1615 21.6644 10.0084 21.3846 10.0558 21.1004L11.1775 14.3697L5.69995 14.3697C5.46322 14.3697 5.24681 14.236 5.14094 14.0242C5.03507 13.8125 5.05791 13.5591 5.19995 13.3697L12.6584 3.4251C12.8313 3.19458 13.1394 3.11214 13.4043 3.22549ZM6.94995 13.1197L11.9153 13.1197C12.0991 13.1197 12.2735 13.2005 12.3922 13.3407C12.511 13.4809 12.562 13.6662 12.5318 13.8475L11.7101 18.7777L16.8807 11.8836L11.9153 11.8836C11.7316 11.8836 11.5572 11.8027 11.4384 11.6625C11.3197 11.5224 11.2686 11.337 11.2988 11.1558L12.1205 6.22559L6.94995 13.1197Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </svg>
)
